import { render, staticRenderFns } from "./productstestreal.vue?vue&type=template&id=319eb75e&"
import script from "./productstestreal.vue?vue&type=script&lang=js&"
export * from "./productstestreal.vue?vue&type=script&lang=js&"
import style0 from "./productstestreal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports